export const phoneRegex = /^\+[0-9]{11}$/;
